var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"align":"end"}},[_c('b-col',[(_vm.schoolList.status === 'DRAFT')?_c('BaseButton',{attrs:{"size":"lg","type":"primary","native-type":"submit"}},[_vm._v(" Sauvegarder en brouillon ")]):(!_vm.readonly)?_c('BaseButton',{attrs:{"size":"lg","type":"primary","native-type":"submit"}},[_vm._v(" Sauvegarder ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }